import styled from "styled-components";

export const PageContent = styled.div`
  padding: ${({ theme }) => theme.space[4]};
  max-width: 960px;
  margin: 0 auto;
`;

export const PageHeader = styled.div`
  margin-bottom: ${({ theme }) => theme.space[5]};
`;

export const PageTitle = styled.h1`
  font-size: ${({ theme }) => theme.fonts.lg};
  font-weight: 700;
  color: ${({ theme }) => theme.colors.primary};
  margin: 0 0 ${({ theme }) => theme.space[1]} 0;
`;

export const PageSubtitle = styled.p`
  font-size: ${({ theme }) => theme.fonts.sm};
  color: ${({ theme }) => theme.colors.gray500};
  margin: 0;
`;

export const SearchBar = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  margin-bottom: ${({ theme }) => theme.space[3]};
`;

export const SearchInput = styled.input`
  width: 100%;
  padding: ${({ theme }) => theme.space[3]};
  padding-left: 40px;
  background-color: ${({ theme }) => theme.colors.gray50};
  border: 1px solid ${({ theme }) => theme.colors.gray200};
  border-radius: ${({ theme }) => theme.radius.md};
  font-size: ${({ theme }) => theme.fonts.sm};
  color: ${({ theme }) => theme.colors.gray800};
  outline: none;
  transition: border-color ${({ theme }) => theme.transitions.fast};

  &::placeholder {
    color: ${({ theme }) => theme.colors.gray400};
    font-style: italic;
  }

  &:focus {
    border-color: ${({ theme }) => theme.colors.primary};
  }
`;

export const CardList = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.space[3]};
`;
